import script from "./importproducts.vue?vue&type=script&setup=true&lang=js"
export * from "./importproducts.vue?vue&type=script&setup=true&lang=js"

import "./importproducts.vue?vue&type=style&index=0&id=25e3eea4&lang=css"

const __exports__ = script;

export default __exports__